module.exports = __webpack_public_path__ + "static/img/wood91.60bff66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood91.jpg
// module id = fw+S
// module chunks = 0